<nav class="sidebar-nav">
  <div class="sidebar-brand">
    <span class="material-symbols-outlined brand-icon">storefront</span>
    <span class="brand-name">Radwa Khallaf</span>
  </div>

  <div class="nav-section">
    <span class="nav-section-label">{{ 'nav.main' | translate }}</span>

    <a class="nav-item" routerLink="home" routerLinkActive="active">
      <span class="material-symbols-outlined">home</span>
      <span class="nav-label">{{ 'nav.home' | translate }}</span>
    </a>

    <a class="nav-item" routerLink="categories" routerLinkActive="active">
      <span class="material-symbols-outlined">category</span>
      <span class="nav-label">{{ 'nav.categories' | translate }}</span>
    </a>
  </div>

  <div class="nav-section">
    <span class="nav-section-label">{{ 'nav.orders' | translate }}</span>

    <a class="nav-item" routerLink="orders" routerLinkActive="active">
      <span class="material-symbols-outlined">receipt_long</span>
      <span class="nav-label">{{ 'nav.active_orders' | translate }}</span>
    </a>

    <a class="nav-item" routerLink="cancelled-orders" routerLinkActive="active">
      <span class="material-symbols-outlined">cancel</span>
      <span class="nav-label">{{ 'nav.cancelled' | translate }}</span>
    </a>

    <a class="nav-item" routerLink="archived-orders" routerLinkActive="active">
      <span class="material-symbols-outlined">inventory_2</span>
      <span class="nav-label">{{ 'nav.archived' | translate }}</span>
    </a>

    <a class="nav-item" routerLink="order_request" routerLinkActive="active">
      <span class="material-symbols-outlined">assignment</span>
      <span class="nav-label">{{ 'nav.order_requests' | translate }}</span>
    </a>

  </div>

  <div class="nav-section">
    <span class="nav-section-label">{{ 'nav.catalog' | translate }}</span>

    <a class="nav-item" routerLink="packages" routerLinkActive="active">
      <span class="material-symbols-outlined">package_2</span>
      <span class="nav-label">{{ 'nav.packages' | translate }}</span>
    </a>

    <a class="nav-item" routerLink="blogs" routerLinkActive="active">
      <span class="material-symbols-outlined">article</span>
      <span class="nav-label">{{ 'nav.blogs' | translate }}</span>
    </a>

    <a class="nav-item" routerLink="promocode" routerLinkActive="active">
      <span class="material-symbols-outlined">confirmation_number</span>
      <span class="nav-label">{{ 'nav.promo' | translate }}</span>
    </a>

    <a class="nav-item" routerLink="delivery" routerLinkActive="active">
      <span class="material-symbols-outlined">local_shipping</span>
      <span class="nav-label">{{ 'nav.delivery' | translate }}</span>
    </a>
  </div>

  <div class="nav-section">
    <span class="nav-section-label">{{ 'nav.people' | translate }}</span>

    <a class="nav-item" routerLink="all_clients" routerLinkActive="active">
      <span class="material-symbols-outlined">group</span>
      <span class="nav-label">{{ 'nav.clients' | translate }}</span>
    </a>

    <a *ngIf="isAdmin" class="nav-item" routerLink="admin-register" routerLinkActive="active">
      <span class="material-symbols-outlined">admin_panel_settings</span>
      <span class="nav-label">{{ 'nav.admin_register' | translate }}</span>
    </a>

    <a *ngIf="isSuperAdmin" class="nav-item" routerLink="all_users" routerLinkActive="active">
      <span class="material-symbols-outlined">manage_accounts</span>
      <span class="nav-label">{{ 'nav.users' | translate }}</span>
    </a>
  </div>
</nav>
